import { Component } from '@angular/core';
import { DataService } from './../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
//Consultas
import { EstructuraService } from './../../../services/Administrador/estructura/estructura.service';
import { QuestionsService } from './../../../services/Administrador/questions/questions.service';
import { AnswersService } from './../../../services/Administrador/answers/answers.service';
//servicios
import { getCuestionarioPorId, getCuestionariosInfo } from './../../../services/Administrador/cuestionarios/query';
import { getQuestions } from './../../../services/Administrador/questions/query_question';
import { CookieService } from 'ngx-cookie-service';
import { environment } from './../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { CuestionariosService } from './../../../services/Administrador/cuestionarios/cuestionarios.service';

import { messages } from '../../funciones/mensajes';

@Component({
  selector: 'app-ponderacion',
  templateUrl: './ponderacion.component.html',
  styleUrl: './ponderacion.component.css'
})
export class PonderacionComponent {
 /* Consultas */
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public nivel1 = false;
  public nivel2 = false;
  public total = 0;
  public publicar = false;
  public edito = false;
  public encabezado = 1;

  public cuestionarios = [];

  public ponderacion = [];
  public ponderacionSin = [];
  public tipoPonderacion = '';
  public menu;

  public cuesSelec = 0;

  public answers = [];
  public questions = [];

  idSel = 0;
  idSel2 = 0;
p: any;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private apollo: Apollo,
    private cookieService: CookieService,
    private cuestionarioService: CuestionariosService,
    private questionsService: QuestionsService,
    private estructuraService: EstructuraService,
    private answersService: AnswersService
  ) {
  }
  ngOnInit(){
    this.ListQuestionnaires();
  }
  
  /* Consultas */
  /* Consultas */
  public async ListQuestionnaires(){
    try{
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionariosInfo,
          context: { headers: this.headers, },
          variables: {
            args: {
              relations: {
                loadRelations: "BASIC"
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "status",
                    operator: "EQUAL",
                    value: "closed"
                  }
                ]
              },
            },
          }
        }).valueChanges.source 
      );
      this.cuestionarios = [];
      
      if (res.data.questionnaires && Array.isArray(res.data.questionnaires)) {
        res.data.questionnaires.forEach((cuestionario) => {
          this.cuestionarios.push({
            id: cuestionario.id,
            name: cuestionario.name,
            status: cuestionario.status,
          });
        });
      }
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* obtención elementos */
  public ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    for(const e of cat){
      const preguntas = this.questions.filter(c => c.categoryId == e.id);
      preguntas.sort(function(a,b){
        if ( Number(a.order) > Number(b.order) ) {
          return 1;
        }
        if ( Number(a.order) < Number(b.order) ) {
          return -1;
        }
        return 0;
      });
      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        elementos: this.ListelementosCategories(elements, e.id),
        questions: this.structureQuestions(e.questions),
        weighting: e.weighting,
      });
    }
    return elementos;
  }
  public structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      newQuestions.push({
        id: q.id,
        name: q.description,
        order: q.order,
        weighting: q.weighting,
        required: q.required,
      });
    }

    return newQuestions;
  }
  /* Mensaje de error consultas */
  private ponderacionMensaje(txt,icon){
    Swal.fire({
      html: txt,
      icon: icon,
      showCancelButton: false,
      showConfirmButton: false,
      // timer: this.dataService.tiempo
    });
  }
  /* Selección de cuestionarios */
  public async seleccionCuestionario(){
    const id = Number(document.getElementById('cuestionario')['value']);
    this.cuesSelec = id;

    try{
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionarioPorId,
          context: { headers: this.headers, },
          fetchPolicy: 'no-cache',
          variables: {
            args: {
              relations: {
                loadRelations: "FULL"
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "id",
                    operator: "EQUAL",
                    value: ""+id
                  }
                ]
              },
            },
          }
        }).valueChanges.source
      );
      const cues = {
        id: res.data.questionnaires[0].id,
        name: res.data.questionnaires[0].name,
        elementos: this.ListelementosCategories(res.data.questionnaires[0].categories, null)
      }

      this.menu = cues;
      this.ponderacion = cues.elementos;
      this.ponderacionSin = JSON.parse(JSON.stringify(cues.elementos));
      this.tipoPonderacion = 'elementos';
      this.edito = false;
      this.getTotal();
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  /* Obtener el total de ponderación */
  public getTotal(){
    this.total = 0;
    for(let i of this.ponderacion){
      this.total += i.weighting;
    }
    this.total = Number(this.total.toFixed(1)) 
  }
  /* Ampliaciones */
  public ampliarNiv1(elem, estado){
    if(estado === 'close' && elem.id === this.idSel){
      this.nivel1 = false;
      this.edito = false;
      this.nivel2 = false;
      this.idSel = 0; 
      this.idSel2 = 0;
    }else if(estado !== 'close' && elem.id !== this.idSel){
      this.nivel1 = true;
      this.idSel = elem.id;
      this.idSel2 = 0;
    }else{
      return;
    }
    
    if(this.nivel1){
      if(elem.elementos.length !== 0){
        this.ponderacion = elem.elementos;
        this.ponderacionSin = JSON.parse(JSON.stringify(elem.elementos));
        this.tipoPonderacion = 'elementos';
        this.encabezado = 1;
      }else{
        this.ponderacion = elem.questions;
        this.ponderacionSin = JSON.parse(JSON.stringify(elem.questions));
        this.tipoPonderacion = 'preguntas';
        this.encabezado = 2;
      }
    }else{
      this.ponderacion = this.menu.elementos;
      this.ponderacionSin = JSON.parse(JSON.stringify(elem.elementos));
      this.tipoPonderacion = 'elementos';
      this.encabezado = 1;
    }
    this.getTotal();
  }
  public ampliarNiv2(elem, i, estado){
    if(estado === 'close' && elem.id === this.idSel && elem.elementos[i].id === this.idSel2){
      this.edito = false;
      this.nivel2 = false;
      this.idSel2 = 0;
    }else if(estado !== 'close' && elem.id === this.idSel && elem.elementos[i].id !== this.idSel2){
      this.nivel2 = true;
      this.idSel2 = elem.elementos[i].id;
    }else{
      return;
    }

    if(this.nivel2){
      if(elem.elementos.length !== 0){
        this.ponderacion = elem.elementos[i].questions;
        this.ponderacionSin = JSON.parse(JSON.stringify(elem.elementos[i].questions));
        this.tipoPonderacion = 'preguntas';
        this.encabezado = 2;
      }else{
        this.ponderacion = elem.elementos;
        this.ponderacionSin = JSON.parse(JSON.stringify(elem.elementos));
        this.tipoPonderacion = 'elementos';
        this.encabezado = 1;
      }
    }else{
      this.ponderacion = elem.elementos;
      this.ponderacionSin = JSON.parse(JSON.stringify(elem.elementos));
      this.tipoPonderacion = 'elementos';
      this.encabezado = 1;
    }
    this.getTotal()
  }
  /* Actualización de peso */
  public actualizarPeso(){
    var i = 0;
    this.edito = true;
    for(const val of this.ponderacion){
      var pesoN = Number(document.getElementById('peso'+i)['value'])
      val.weighting = pesoN;
      i++;
    }
    this.getTotal();
  }
  /* Validación de pesos cuestionario */
  public validarCuestionario(){
    var total1 = 0, total2 = 0, total3 = 0;
    for(let c of this.menu.elementos){
      total1 += c.weighting;
      total1 = Number(total1.toFixed(1));
      if(c.elementos.length !== 0){
        for(let e of c.elementos){
          total2 += e.weighting;
          total2 = Number(total2.toFixed(1));
          if(e.questions.length !== 0){
            for(let p1 of e.questions){
              total3 += p1.weighting;
              total3 = Number(total3.toFixed(1));
            }
            if(total3 < 100){
              const mensaje = this.translate.instant('admin.ponderacion.validaPonderacionElemento',{
                elementoNombre: e.name,
                componenteNombre: c.name
              });
              this.ponderacionMensaje(mensaje,'info');
              return;
            }else{
              total3 = 0;
            }
          }          
        }
        if(total2 < 100){
          const mensaje = this.translate.instant('admin.ponderacion.validaPonderacionComponente',{
            componenteNombre: c.name
          });
          this.ponderacionMensaje(mensaje, 'info');
          return;
        }else{
          total2 = 0;
        }
      }
    }
    if(total1 < 100){
      const mensaje = this.translate.instant('admin.ponderacion.validaCuestionarioCompleto');
      this.ponderacionMensaje(mensaje, 'info');
      return;
    }else{
      this.publicar = true;
      const mensaje = this.translate.instant('admin.ponderacion.ponderacionCuestionarioCompleto',{
        cuestionarioNombre: this.menu.name
      });
      this.ponderacionMensaje(mensaje, 'success' )
      total1 = 0;
    }
    return;
  }
  /* Ponderación automatica */
  public ponderacionAuto(){
    this.edito = true;
    let valor = Number((100/this.ponderacion.length).toFixed(1)), i = 0;
    for(const p of this.ponderacion){
      if(100 > valor*this.ponderacion.length && i === this.ponderacion.length-1){
        const fal = Number((100-valor*this.ponderacion.length).toFixed(1))
        p.weighting = Number((valor+fal).toFixed(1));
      }else if(100 < valor*this.ponderacion.length && i === this.ponderacion.length-1){
        const fal = Number((100-valor*this.ponderacion.length).toFixed(1))
        p.weighting = Number((valor+fal).toFixed(1));
      }else{
        p.weighting = valor;
      }
      i++;
    }
    this.getTotal();
  }
  /* verificación de edición */
  public async editoD(){
    if(this.edito){
      const result = await messages.confirmationSave(
        this.translate.instant('admin.ponderacion.tituloCambiosNoGuardados'),
        this.translate.instant('admin.ponderacion.textoCambiosNoGuardados'),
        this.translate
      );
      if(result){
        for(var i = 0; i<this.ponderacion.length; i++){
          this.ponderacion[i].weighting = this.ponderacionSin[i].weighting;
        }
        this.edito = false;
      }
    }
  }
  /* Guardar ponderación */
  public async guardarPonderacion(){
    for(const d of this.ponderacion ){
      if(this.tipoPonderacion === 'elementos'){
        try{
          const res = await firstValueFrom(this.estructuraService.updateCategoriaPonderacion(d));
        }catch(err){
          messages.errorMessageGraph(err.error.message);
          return;
        }
      }else{
        try{
          const res = firstValueFrom(this.questionsService.updateQuestionWeighting(d));
        }catch (err){
          messages.errorMessageGraph(err.error.message);
          return;
        }
      }
    }
    for(var i = 0; i<this.ponderacion.length; i++){
      this.ponderacionSin[i].weighting = this.ponderacion[i].weighting;
    }
    this.edito = false;
    messages.succesMessageGraph(this.translate.instant('admin.cuestionarios.succesN'));
  }

  public async changeStatus(){
      const result = await messages.confirmationSave(
        this.translate.instant('admin.estructura.publicar2'),
        this.translate.instant('acciones.continuar'),
        this.translate
      );
      if(result){
        try {
          await firstValueFrom(this.cuestionarioService.statusCuestionario(this.cuesSelec+'', 'ready'));
          this.cuesSelec = undefined;

          messages.succesMessageGraph(this.translate.instant('admin.estructura.succesE'))
          setTimeout(()=>{
            window.location.reload();
          }, 1500)
        } catch (error: any) {
            messages.errorMessageGraph(error.error.message);
        }            
      }
         
    }
}
